import * as React from 'react';

const DutchIcon = ({ size = 36 }) => {
    return (
        <svg width={size} height={size} viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <clipPath id='circle-nl'>
                <circle cx={15} cy={11} r={10} />
            </clipPath>
            <g clipPath='url(#circle-nl)'>
                <rect x={5} y={1} width={20} height={6.67} fill='#AE1C28' />
                <rect x={5} y={7.67} width={20} height={6.67} fill='#FFFFFF' />
                <rect x={5} y={14.34} width={20} height={6.67} fill='#21468B' />
            </g>
            <circle cx={15} cy={11} r={10} stroke='#e0e0e0' strokeWidth={0.5} fill='none' />
        </svg>
    );
};

export default DutchIcon;
